import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

const useLocalStorage = () => {
  const { currentAdmin, currentUser } = useDefaultAppContexts();
  const userId = currentAdmin?.id || currentUser?.id || 0;

  const set = (key: string, value: any): void => {
    localStorage.setItem(`hb-${key}-${userId}`, JSON.stringify(value));
  };

  const get = (key: string): any => {
    const value = localStorage.getItem(`hb-${key}-${userId}`);

    return value ? JSON.parse(value) : null;
  };

  const remove = (key: string): void => {
    localStorage.removeItem(`hb-${key}-${userId}`);
  };

  return {
    set,
    get,
    remove,
  };
};

export { useLocalStorage };
